/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { Box, Image, Text } from '@chakra-ui/react'
import { Link } from '@ui'
import { ISelectionsFromCollectionCard } from '@interfaces'

const SelectionsFromCollectionCard = ({
  variant = 'primary',
  people,
  artist,
  title,
  name,
  date,
  nameUrl,
  url,
  imgUrl,
  onClick,
  isDarkSection = true,
  containerProps,
  activeFontFamily = 'body',
}: ISelectionsFromCollectionCard) => {
  const metaColor = isDarkSection ? 'grey.primary' : 'black.primary3'
  const titleColor = isDarkSection ? 'white.primary' : 'black.primary3'

  const cardContent = (
    <>
      <Box overflow="hidden" borderRadius="sm" mb="3">
        <Image
          w="full"
          h="auto"
          objectFit="cover"
          src={imgUrl}
          fallbackSrc="/img/placeholders/no-image-available-icon.jpeg"
          alt={title}
          transition="transform 0.35s ease"
          _groupHover={{ transform: 'scale(1.03)' }}
        />
      </Box>

      {title && (
        <Text
          color={titleColor}
          fontFamily={activeFontFamily}
          fontSize={{ base: 'sm', lg: 'md' }}
          fontWeight="medium"
          lineHeight="short"
          mb="1.5"
        >
          {title}
        </Text>
      )}

      {artist && (
        <Text
          fontFamily={activeFontFamily}
          fontSize="sm"
          fontWeight="light"
          fontStyle="italic"
          textDecoration="underline"
          color={metaColor}
          lineHeight="short"
          mb={date ? '1' : '0'}
          noOfLines={2}
        >
          {artist}
        </Text>
      )}

      {date && (
        <Text
          fontFamily={activeFontFamily}
          fontSize="xs"
          fontWeight="light"
          color={metaColor}
          opacity={0.85}
          lineHeight="short"
        >
          {date}
        </Text>
      )}
    </>
  )

  if (variant === 'withPopUp') {
    return (
      <Box
        role="group"
        display="block"
        transition="all 0.3s ease"
        cursor="pointer"
        _hover={{ transform: 'translateY(-4px)' }}
        onClick={onClick}
        {...containerProps}
      >
        {cardContent}
        {name && (
          <Text color={metaColor} fontSize="xs" mt="1" noOfLines={1}>
            {name}
          </Text>
        )}
      </Box>
    )
  }

  return (
    <Box
      role="group"
      transition="all 0.3s ease"
      _hover={{ transform: 'translateY(-4px)' }}
      {...containerProps}
    >
      <Link
        href={url}
        display="block"
        _hover={{ textDecoration: 'none' }}
        onClick={onClick}
      >
        {cardContent}
      </Link>

      {nameUrl && (
        <Link href={nameUrl} display="none" mt="2">
          <Text color={metaColor} fontSize="xs" textDecoration="underline">
            {name}
          </Text>
        </Link>
      )}

      {name && !nameUrl && (
        <Link href={url} display="block" mt="2">
          <Text
            color={metaColor}
            fontSize="xs"
            textDecoration="underline"
            noOfLines={1}
          >
            {name}
          </Text>
        </Link>
      )}
    </Box>
  )
}

export default SelectionsFromCollectionCard
